export default __webpack_public_path__ + "static/media/brand.e155cc3f.png";